export default __webpack_public_path__ + "static/media/Picture5.e3b800b4.png";